<template>
  <div class="bounty-board-event-box flexing" :data-event-theme="namespace">
    <div v-if="loaded" class="bounty-board-event-box__content">
      <div v-if="activeTask">
        <bounty-board-task :task="activeTask" />
      </div>
      <div v-else class="flexing flex-col">
        <span class="text-36 font-medium text-texts-standard-default">{{
          $te('noActiveEventTasks')
        }}</span>
        <app-button
          btn-id="bounty-board-event-box-btn"
          btn-type="primary"
          :btn-text="$te('noticeBoard')"
          class="mt-6"
          :disabled="false"
          @click="redirectView"
        />
      </div>
    </div>
    <component-loading v-else :is-loading="true" height="100%" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import BountyBoardTask from '@/components/Events/BoardComponents/BountyBoard/BountyBoardTask.vue'
import { mapActions, mapState } from 'pinia'
import { useTaskBoardStore } from '@/store/pinia/events/taskBoardStore'
import { useEventInfoStore } from '@/store/pinia/events/eventInfoStore'
import type { BoardTask } from '@/interfaces/responses/events/task-board/TaskBoardStateApiResponse'

interface ComponentData {
  loaded: boolean
}

export default defineComponent({
  name: 'BountyBoardEventBox',
  components: {
    BountyBoardTask,
  },
  data(): ComponentData {
    return {
      loaded: false,
    }
  },
  computed: {
    ...mapState(useEventInfoStore, {
      namespace: 'getEventType',
    }),
    ...mapState(useTaskBoardStore, {
      tasks: 'getTasks',
    }),
    activeTask(): BoardTask {
      const tasks = Object.values(this.tasks)
      return tasks.find((task: BoardTask): boolean => !!task.active)
    },
  },
  async created(): Promise<void> {
    this.loaded = false
    await this.loadState()
    this.loaded = true
  },
  methods: {
    ...mapActions(useTaskBoardStore, {
      loadState: 'loadState',
    }),
    redirectView(): void {
      this.$router.push({ name: this.$getWebView('EventsBoard') })
    },
  },
})
</script>

<style lang="scss">
.bounty-board-event-box {
  width: 89.063rem;
  height: 44.5rem;
  position: relative;
}
[data-event-theme='autumn'] {
  &.bounty-board-event-box {
    background: url($path-events + 'autumn-fair/BoardMain-bg.avif') no-repeat center;
    background-size: cover;
  }
}
[data-event-theme='fortune_festival'] {
  &.bounty-board-event-box {
    background: url($path-events + 'fortune-festival/BoardMain-bg.avif') no-repeat center;
    background-size: cover;
  }
}
</style>
